<div class="applicationUpdates-container">
  <mat-card class="applicationUpdates-content">
    <div class="rowTwo">
      <mat-card-title>
        <h2 class="card-title">Application Updates</h2>
      </mat-card-title>
      <div class="actions-box">
        <mat-form-field appearance="outline" class="applicationupdate-search">
          <input
            matInput
            #search
            (keyup)="applyFilter($event.target.value)"
            maxlength="256"
            placeholder="Search"
          />
          <mat-icon matSuffix>search</mat-icon>
          <mat-hint align="start"
            >Example: Name, Application #, Seneca ID</mat-hint
          >
        </mat-form-field>
      </div>
    </div>

    <!-- table -->
    <mat-card-content
      class="applicationUpdates-content"
      style="overflow-y: auto"
    >
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="student_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>Last Name, First Name</b>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.student_name }}</td>
        </ng-container>

        <ng-container matColumnDef="iwa_application_number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>Application No.</b>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.iwa_application_number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="student_number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>Student No.</b>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.student_number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="admit_term_description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header><b>Term</b></th>
          <td mat-cell *matCellDef="let element">
            {{ element.admit_term_description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="program_code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>Program Code</b>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.program_code }}</td>
        </ng-container>

        <ng-container matColumnDef="campus_description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>Campus</b>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.campus_description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b> Date</b>
          </th>
          <td mat-cell *matCellDef="let element">{{ element.action_date }}</td>
        </ng-container>

        <ng-container matColumnDef="reason_description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>Application Status</b>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.reason_description }}
          </td>
        </ng-container>

        <ng-container matColumnDef="readStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>Status</b>
          </th>
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="element.readStatus === 0; else readStatus"
              >{{ "Unread " }}
            </ng-container>
            <ng-template #readStatus>{{ "Read " }} </ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="offer_letter">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            <b>Last Communication Date</b>
          </th>
          <td mat-cell *matCellDef="let element">
            <button
              *ngIf="element.offer_letter && element.offer_letter !== ' '"
              type="button"
              class="uploadButton"
              mat-button
              id="uploadButton"
              color="primary"
              (click)="openOfferLetter(element)"
            >
              {{ element.offer_letter.slice(0, 10) }}
              <br />
              <mat-icon>download</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="onRowClicked($event, row)"
          [ngClass]="{ 'bold-row': row.readStatus === 0 }"
        ></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      ></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>

<div *ngIf="communicationPdfLoading" class="loading-indicator">
  <mat-spinner diameter="100" strokeWidth="15"></mat-spinner>
</div>
